<template>
  <div>
    <PoolBalanceV1 v-if="isVersionV1" :pool="props.pool as PoolV1" />
    <PoolBalanceV0 v-else :pool="props.pool as PoolV0" />
  </div>
</template>
<script lang="ts" setup>
import {
  IPersistedPoolV1,
  IPersistedPool,
  IPersistedTokenExtended,
} from '@/types/pools';
import PoolBalanceV0 from './PoolBalanceV0.vue';
import PoolBalanceV1 from './PoolBalanceV1.vue';

type PoolV0 = IPersistedPool & {
  tokenEntities: {
    fromTokenEntity: IPersistedTokenExtended;
    toTokenEntity: IPersistedTokenExtended;
  };
};
type PoolV1 = IPersistedPoolV1 & {
  tokenEntities: {
    fromTokenEntity: IPersistedTokenExtended;
    toTokenEntity: IPersistedTokenExtended;
  };
};

interface IProps {
  pool: PoolV0 | PoolV1;
  isVersionV1: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isVersionV1: false,
});
</script>
